@if(service.viewDroplistItems.length){
<div class="volunteering-mentors-views-part">

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='uniqueId' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.MentorPool) {
	<mentor-pool-view-part></mentor-pool-view-part>
	}
	@case (service.viewId.PendingSignUps) {
	<mentors-pending-sign-ups-view-part></mentors-pending-sign-ups-view-part>
	}
	@case (service.viewId.RejectedSignUps) {
	<mentors-rejected-sign-ups-view-part></mentors-rejected-sign-ups-view-part>
	}
	@case (service.viewId.AcceptedSignUps) {
	<mentors-accepted-sign-ups-view-part></mentors-accepted-sign-ups-view-part>
	}
	@case (service.viewId.Backups) {
	<mentors-back-ups-view-part></mentors-back-ups-view-part>
	}
	@case (service.viewId.AllMentors) {
	<volunteering-all-mentors-view-part></volunteering-all-mentors-view-part>
	}
	@case (service.viewId.DroppedOutMentors) {
	<volunteering-mentor-dropouts-view-part></volunteering-mentor-dropouts-view-part>
	}
	}
	}

</div>
}